<template>
  <div class="event-form" v-if="newEvent">
    <section>
      <div class="event-form--section-title">
        <span>Notifications</span>
        Share event details
      </div>
      <div class="event-form--content event-form--notifications">
        <template v-if="newEvent.notifications?.length">
          <div
            v-for="(notification, index) in newEvent.notifications"
            :key="index"
            class="event-form--row event-form--row-flex"
          >
            <InputText name="email" v-model="notification.email" label="Email Address *" />

            <PhoneNumber
              v-model:phone_country_code="notification.phone_country_code"
              v-model:phone_number="notification.phone_number"
            />

            <Button
              severity="contrast"
              icon=""
              outlined
              aria-label="Remove notification"
              @click="removeNotification(notification, index)"
            >
              <IconRemove />
            </Button>
          </div>
        </template>
        <template v-else>
          <div class="event-form--row event-form--row-flex">No notifications set</div>
        </template>
      </div>
    </section>

    <div class="event-form--notifications-new">
      <Button severity="primary" @click="addNotification()">
        <IconPlus />
        Add New
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import InputText from '@/components/inputs/InputText.vue';
import { Button } from 'primevue';

import type { EventNotification, EventTypeNew } from '@/types/Event';

import IconRemove from '@/icons/IconRemove.svg?component';
import IconPlus from '@/icons/IconPlus.svg?component';
import PhoneNumber from '@/components/inputs/PhoneNumber.vue';

const newEvent = defineModel<EventTypeNew>('newEvent');

const removeNotification = (notification: EventNotification, index: number) => {
  newEvent.value?.notifications?.splice(index, 1);
};

const addNotification = () => {
  newEvent.value?.notifications?.push({
    email: '',
    phone_country_code: null,
    phone_number: '',
  });
};
</script>
